<div class="full-height layout-column overflow-hidden">
  <div class="flex layout-column bringoz-table">

    <div class="tr text-uppercase layout-row layout-align-start-center">

      <!--ID-->
      <div class="th layout-row layout-align-start-center
           flex-5 text-ellipsis text-left">
        #
        <app-bringoz-checkbox class="margin-left-5"
                              [isDisabled]="!paginationData?.content.length"
                              [isChecked]="(!excludeMode && !!selectedIds.length) || (excludeMode && !selectedIds.length)"
                              [isIndeterminate]="(!excludeMode && !!selectedIds.length && paginationData?.totalElements > selectedIds.length) || excludeMode && !!selectedIds.length"
                              (clickEvent)="onToggleSelectAll()">
        </app-bringoz-checkbox>
      </div>

      <!--Account-->
      <div class="th layout-row layout-align-start-center
           flex-15 text-ellipsis text-left">
        <span translate>Account</span>
      </div>

      <!--Date-->
      <div class="th layout-row layout-align-start-center
           flex-15 text-ellipsis text-left">
        <span translate>Date</span>
      </div>

      <!--Details-->
      <div class="th layout-row layout-align-start-center
           flex text-ellipsis text-left">
        <span class="flex" translate>Call Type</span>
        <span class="flex" translate>Field</span>
        <span class="flex" translate>Previous Value</span>
        <span class="flex" translate>Current Value</span>
        <!--      <span class="flex" translate>Last Modified</span>-->
      </div>

    </div>

    <div class="full-height flex rows-container layout-column overflow-auto">
      <ng-container *ngIf="!!paginationData?.content.length">
        <div *ngFor="let change of paginationData.content; let index= index" class="tr">
          <div class="layout-row layout-align-start-center">
            <div class="td layout-row flex-5 text-ellipsis">
              {{ index + 1 }}

              <app-bringoz-checkbox class="margin-left-5"
                                    [isChecked]="(!excludeMode && selectedKeys[change.id]) || (excludeMode && !selectedKeys[change.id])"
                                    (clickEvent)="onToggleSelect(change);$event.stopPropagation()">
              </app-bringoz-checkbox>

            </div>
            <div [ngbTooltip]="change.accountReference.name" openDelay="300" triggers="hover"
                 class="td layout-row flex-15">
              <span class="text-ellipsis-multi-lines-3">{{ change.accountReference.name }}</span>
            </div>
            <div class="td layout-row flex-15 text-ellipsis">
              {{ change | bringozDay: 'date': 'long' }} {{ change | bringozDate: 'date' }}
            </div>
            <div class="td layout-column flex text-ellipsis">
              <div *ngFor="let changeDetail of accountChangesMap[index]; let last = last" class="layout-column"
                   [ngClass]="{'margin-bottom-5': !last}">
                <div class="flex layout-row layout-align-start-center">
                  <span class="flex" translate>{{ siteProgramTypesMap[changeDetail.callType] }}</span>
                  <span class="flex">{{ 'VISIT_PLAN_TRACKER_FIELDS.' + changeDetail.key | translate }}</span>
                  <span class="flex text-ellipsis"
                        [ngbTooltip]="changeDetail.previous"
                        openDelay="300"
                        triggers="hover">
                  {{ changeDetail.previous }}
                </span>
                  <span class="flex text-ellipsis"
                        [ngbTooltip]="changeDetail.pending"
                        openDelay="300"
                        triggers="hover">{{ changeDetail.pending }}</span>
                  <!--              <span class="flex" translate>Last Modified</span>-->
                </div>
                <hr *ngIf="!last" class="main-divider">
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!--  <hr class="main-divider margin-bottom-0">-->
    <loader [isDisplayLoader]="isLoadingData"></loader>

  </div>

  <div class="layout-row layout-align-center-center padding-5">
    <app-bringoz-pagination *ngIf="paginationData?.totalElements > size"
                            [pageIndex]="page + 1"
                            [totalElements]="paginationData?.totalElements"
                            [elementsPerPage]="size"
                            (pageIndexChangeEvent)="onPaginationChange($event)">

    </app-bringoz-pagination>
  </div>
</div>
